import { render, staticRenderFns } from "./BaseBadge.vue?vue&type=template&id=1b6493c8&scoped=true"
import script from "./BaseBadge.vue?vue&type=script&lang=js"
export * from "./BaseBadge.vue?vue&type=script&lang=js"
import style0 from "./BaseBadge.vue?vue&type=style&index=0&id=1b6493c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6493c8",
  null
  
)

export default component.exports